// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span[data-v-91db20c4]:after{content:\"\";position:absolute;bottom:-5px;left:0;width:100%;height:24px;background-color:#f7eee6;z-index:-1}", ""]);
// Exports
module.exports = exports;
